import { Fragment } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { IconName } from '@optimus-web/core';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import {
    hasCurrentEnterpriseServiceId,
    getCurrentEnterpriseUserPreferredServiceId,
} from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import {
    hasCurrentEnterpriseServiceProviderMode,
    areCurrentEnterpriseCustomerStatisticsEnabled,
} from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import {
    isCurrentProfileEnabledToManageCustomers,
    isCurrentProfileEnabledToManageCompanies,
    hasReadOnlyPrivilegesForCustomerData,
    hasReadOnlyPrivilegesForCompanyData,
    canCurrentProfileManageTravelAgencies,
} from '@mews-commander/legacy-entities/src/selectors/session/scope';
import { createListItemWithLink } from '../helpers';
import { SidebarExpandableListItem, SidebarFontIcon } from '../style';

const ProfileMenu = ({
    hasReservableService,
    hasServiceProviderMode,
    isCustomerManager,
    isCompaniesManager,
    isTravelAgeneciesManager,
    customerStatisticsEnabled,
    serviceId,
    readOnlyCompany,
    readOnlyCustomer,
    ...other
}: $TSFixMe) => {
    const currentEnterprise = useCurrentEnterprise();
    if (!hasServiceProviderMode) {
        return null;
    }

    return (
        <SidebarExpandableListItem
            leftIcon={<SidebarFontIcon value={IconName.Profile} />}
            primaryText={<LocalizedText textKey={TextKey.ProfilePlural} />}
            {...other}
        >
            {currentEnterprise.id && (
                <Fragment>
                    {isCustomerManager && (
                        <Fragment>
                            {createListItemWithLink({
                                textKey: TextKey.AddCustomer,
                                iconName: IconName.AddCustomer,
                                path: 'Customer/Create',
                                search: { RedirectToProfile: true, chainId: currentEnterprise.chainId },
                            })}
                            {customerStatisticsEnabled
                                ? createListItemWithLink({
                                      textKey: TextKey.CustomerStatisticReport,
                                      iconName: IconName.Statistics,
                                      path: 'CustomerStatisticReport/Index',
                                  })
                                : null}
                            {hasReservableService
                                ? createListItemWithLink({
                                      textKey: TextKey.CustomerProfileReport,
                                      iconName: IconName.CustomerProfiles,
                                      path: 'CustomerProfileReport/Index',
                                      search: { 'Service.Id': serviceId },
                                  })
                                : null}
                        </Fragment>
                    )}
                    {!isCustomerManager && readOnlyCustomer && (
                        <Fragment>
                            {createListItemWithLink({
                                textKey: TextKey.CustomerStatisticReport,
                                iconName: IconName.Statistics,
                                path: 'CustomerStatisticReport/Index',
                            })}
                            {createListItemWithLink({
                                textKey: TextKey.CustomerProfileReport,
                                iconName: IconName.CustomerProfiles,
                                path: 'CustomerProfileReport/Index',
                                search: { 'Service.Id': serviceId },
                            })}
                        </Fragment>
                    )}
                    {isCompaniesManager || readOnlyCompany
                        ? createListItemWithLink({
                              textKey: TextKey.CompanyPlural,
                              iconName: IconName.Property,
                              path: 'CompanyReport/Index',
                          })
                        : null}
                    {isTravelAgeneciesManager && hasReservableService
                        ? createListItemWithLink({
                              textKey: TextKey.TravelAgencyContractPlural,
                              iconName: IconName.TravelAgency,
                              path: 'TravelAgencyContractReport/Index',
                          })
                        : null}
                    {hasReservableService &&
                        isCustomerManager &&
                        createListItemWithLink({
                            textKey: TextKey.TimeSpentReport,
                            iconName: IconName.SpentNights,
                            path: 'TimeSpentReport/Index',
                            search: { 'Service.Id': serviceId },
                        })}
                </Fragment>
            )}
        </SidebarExpandableListItem>
    );
};

export default connect(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    createStructuredSelector({
        hasServiceProviderMode: hasCurrentEnterpriseServiceProviderMode,
        hasReservableService: hasCurrentEnterpriseServiceId,
        isCustomerManager: isCurrentProfileEnabledToManageCustomers,
        isCompaniesManager: isCurrentProfileEnabledToManageCompanies,
        isTravelAgeneciesManager: canCurrentProfileManageTravelAgencies,
        customerStatisticsEnabled: areCurrentEnterpriseCustomerStatisticsEnabled,
        serviceId: getCurrentEnterpriseUserPreferredServiceId,
        readOnlyCompany: hasReadOnlyPrivilegesForCompanyData,
        readOnlyCustomer: hasReadOnlyPrivilegesForCustomerData,
    })
)(ProfileMenu);
